import type { IAppSettings } from '@/types';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { ECurrency } from '@/enum';

const DEFAULT_SETTINGS: IAppSettings = {
  language: 'ar',
  direction: 'rtl',
  dateFormat: 'dd-mm-yyyy',
  currency: ECurrency.KWD,
};

interface ISettingsState {
  settings: IAppSettings;
  updateSettings: (s: Partial<IAppSettings>) => void;
}

export const useSettingsStore = create<ISettingsState>()(
  persist(
    (set, get) => ({
      settings: DEFAULT_SETTINGS,

      updateSettings: (newSettings) => {
        const updated = {
          ...get().settings,
          ...newSettings,
        };

        set({ settings: updated });
      },
    }),
    {
      name: 'app_settings', // localStorage key
    }
  )
);
